// extracted by mini-css-extract-plugin
module.exports = {"Checkbox":"Checkbox_Checkbox__1o3yx"};